import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";

// Eager metadata registration; the render component code-splits into its own
// tpl-icon-section chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'icon-section-widget',
    name: 'Icon section widget',
    description: 'Icon section widget',
    complexity: 'easy',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-icon-section" */ "./IconSection")),
})
